// extracted by mini-css-extract-plugin
module.exports = {"fondo":"error_fondo__rjP-1","boxError":"error_boxError__1cBbT","divError":"error_divError__1UjEk","boton":"error_boton__3E6yT","margin":"error_margin__a25_W"};